import { BuybackReceivedLine } from '../BuybackReceivedLine';

/** How long sleek keeps a sale's or a vault's result on screen before it
 *  moves on by itself — the reveal's last pack, a card sold from the Vault
 *  (partner Figma 2026-10-15). */
export const SLEEK_RESULT_HOLD_MS = 1500;

/** The credited amount and where it went — the caption takes the FMV
 *  label's slot and knobs, so the line reads as the same block, resolved. */
export function SoldLine({ amount }: { amount: number }) {
  return (
    <div className="flex flex-col items-center">
      <BuybackReceivedLine amount={amount} />
      <span
        data-co-component="WinnerStepFMV"
        style={{
          color: 'var(--co-WinnerStepFMV-color, #6D707C)',
          fontFamily: 'var(--co-WinnerStepFMV-font, "Inter"), Inter, sans-serif',
          fontSize: 'var(--co-WinnerStepFMV-size, 14px)',
          lineHeight: '20px',
          letterSpacing: '-0.15px',
        }}
      >
        Added to your wallet
      </span>
    </div>
  );
}
